import {Box, Button, Chip, Container, Divider, Icon, IconButton, Paper, Stack, TextField, ToggleButton, ToggleButtonGroup, Typography} from "@mui/material";
import PageHeader from "../../components/PageHeader";
import {ClientDto, ClientService, UserDetailDto, UserService, UserStatus} from "../../api/psc.ts";
import {useNavigate, useParams} from "react-router-dom";
import {ChangeEvent, useContext, useEffect, useState} from "react";
import Spinner from "../../components/Spinner";
import {DialogContext} from "../../contexts/DialogueContext";
import ConfirmationDialog from "./ConfirmationDialog";
import UserAccessDialog from "./UserAccessDialog";
import SetPasswordDialog from "./SetPasswordDialog";

export default function UpdateUser() {

    const params = useParams()
    const navigate = useNavigate()
    const {openDialog} = useContext(DialogContext)

    const userId = parseInt(params['id'])

    const [user, setUser] = useState<UserDetailDto | null>(null)

    const [username, setUsername] = useState("")
    const [firstName, setFirstName] = useState("")
    const [lastName, setLastName] = useState("")
    const [mobileNumber, setMobileNumber] = useState("")
    const [status, setStatus] = useState(UserStatus.ACTIVE)
    const [requestInProgress, setRequestInProgress] = useState(false)


    useEffect(() => {
        fetchUserDetail()
    }, [])

    const fetchUserDetail = () => {
        setUser(null)
        UserService.getUserById(userId).then(r => {
            setUser(r)
            setUsername(r.username)
            setFirstName(r.firstName)
            setLastName(r.lastName)
            setMobileNumber(r.mobileNumber)
            setStatus(r.status)
        })
    }

    const handleUsernameChange = (event: ChangeEvent<HTMLInputElement>) => {
        setUsername(event.target.value);
    }

    const handleFirstNameChange = (event: ChangeEvent<HTMLInputElement>) => {
        setFirstName(event.target.value);
    }

    const handleLastNameChange = (event: ChangeEvent<HTMLInputElement>) => {
        setLastName(event.target.value);
    }

    const handleMobileNumberChange = (event: ChangeEvent<HTMLInputElement>) => {
        setMobileNumber(event.target.value);
    }

    const submit = () => {
        setRequestInProgress(true)
        UserService.updateUser(userId, {
            lastName,
            firstName,
            username,
            mobileNumber,
            status
        }).then(r => {
            navigate('/')
            setRequestInProgress(false)
        }).finally(() => {
            setRequestInProgress(false)
        })
    }

    const handleUpdateAccess = () => {
        openDialog(<UserAccessDialog user={user}/>, (didUpdate) => {
            fetchUserDetail()
        })
    }

    const handleChangePassword = () => {
        openDialog(<SetPasswordDialog user={user}/>)
    }

    const handleDeleteUser = () => {
        openDialog(<ConfirmationDialog title='حذف کاربر؟' onAccept={() => {
            UserService.deleteUser(userId).then(r => {
                navigate('/')
            })
        }
        }/>)
    }

    const handleStatusChange = (event: React.MouseEvent<HTMLElement>, value: UserStatus) => {
        if (!value) {
            return
        }
        setStatus(value)
    }

    if (user === null) {
        return <Spinner/>
    }

    return <Container maxWidth='sm'>
        <PageHeader title='ویرایش کاربر' action={
            <Stack direction='row' spacing={2}>
                <Button size='small' variant='outlined' color='error' startIcon={<Icon>delete</Icon>} onClick={handleDeleteUser}>
                    حذف کاربر
                </Button>
                <Button size='small' variant='outlined' onClick={handleUpdateAccess} startIcon={<Icon>add</Icon>}>
                    افزودن دسترسی
                </Button>
                <Button size='small' color='secondary' variant='outlined' onClick={handleChangePassword} startIcon={<Icon>lock</Icon>}>
                    تغییر رمز عبور
                </Button>
            </Stack>
        }/>

        <Paper sx={{p: 2}}>

            <Stack spacing={2} flex={1}>
                <ToggleButtonGroup
                    fullWidth
                    color="primary"
                    value={status}
                    exclusive
                    onChange={handleStatusChange}>
                    <ToggleButton color='success' value={UserStatus.ACTIVE}>فعال</ToggleButton>
                    <ToggleButton color='error' value={UserStatus.DE_ACTIVE}>غیر فعال</ToggleButton>
                </ToggleButtonGroup>

                <TextField label='نام کاربری' value={username} onChange={handleUsernameChange}/>
                <TextField label='نام' value={firstName} onChange={handleFirstNameChange}/>
                <TextField label='نام خانوادگی' value={lastName} onChange={handleLastNameChange}/>
                <TextField label='شماره موبایل' value={mobileNumber} onChange={handleMobileNumberChange}/>

                <Button disabled={requestInProgress} onClick={submit} variant='contained'>
                    ویرایش کاربر
                </Button>
            </Stack>

        </Paper>

    </Container>
}
